import { Box } from '@mui/system'
import EdgeLogo from 'assets/logos/edge-logo.svg'
import { RouteName } from 'constants/constants'
import CoreNavBar from 'core/CoreNavBar'
import { observer } from 'mobx-react-lite'
import { accountStore } from 'stores'
import Invitation from './Invitation'
import WalletConnector from './WalletConnector'

const Navbar = observer(() => {
  const RightComponent = (
    <Box display="flex" gap="16px">
      {accountStore.eligible && <Invitation />}
      <WalletConnector />
    </Box>
  )
  return (
    <Box sx={{ paddingY: '26px', marginBottom: '-107.5px' }}>
      <CoreNavBar
        logo={EdgeLogo}
        menus={[
          { label: 'Beta launch', path: RouteName.pool },
          { label: 'FAQs', path: RouteName.faqs },
        ]}
        rightComponent={RightComponent}
      />
    </Box>
  )
})

export default Navbar
